"use client";
import {useDropzone} from "react-dropzone";
import {RiFileDownloadLine} from "react-icons/ri";
import {useCallback, useMemo, useState} from "react";
import {cn} from "@/lib/utils";
import {ScrollArea} from "@/components/ui/scroll-area";

export default function CWFFileDropzone({accept, maxFiles, acceptInfo, onDrop, error,maxSize}){
    const [isTooLarge, setIsTooLarge] = useState(false);
    const [isInvalid, setIsInvalid] = useState(false);
    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragActive,
        isDragAccept,
        isDragReject,
        acceptedFiles,
        fileRejections,
    } = useDropzone({accept, maxFiles, onDrop, maxSize,onDropRejected, onDropAccepted});

    const containerStyle = useMemo(() => cn(
        `transition-colors cursor-pointer hover:border-blue-500 hover:bg-blue-50 rounded-lg h-32 w-full border-2 
        border-dashed border-neutral-500 text-neutral-500 bg-neutral-100 flex flex-col items-center justify-center gap-2
        overflow-x-hidden`,
        error && "border-red-500 bg-red-50",
        (isFocused || isDragActive) && "border-blue-500 bg-blue-50",
        isDragAccept && "border-green-500 bg-green-50",
        isDragReject && "border-red-500 bg-red-50",
        isTooLarge && "border-red-500 bg-red-50",
    ), [isFocused, isDragAccept, isDragReject, isDragActive, error,isTooLarge]);


    function onDropRejected(fileRejections, event){
        setIsInvalid(false);
        setIsTooLarge(false);
        if(fileRejections[0].errors[0].code === 'file-too-large'){
            setIsTooLarge(true);
        }

        if(fileRejections[0].errors[0].code === 'file-invalid-type'){
            setIsInvalid(true);
        }

    }

    function onDropAccepted(files,event){
        setIsTooLarge(false);
        setIsInvalid(false);
    }

    //console.log("Status of fileRejections", fileRejections);
    return (
        <div
            {...getRootProps()}
            className={containerStyle}
        >
            <input {...getInputProps()} />
            {acceptedFiles?.length > 0 ? (
                <ScrollArea orientation="horizontal" className="max-w-full py-3">
                    <div className="relative h-24 flex gap-2 px-2">
                        {acceptedFiles.map((file, index) => (

                             <p key={index}>{file.name}</p>
                        ))}
                    </div>
                </ScrollArea>
            ) : (
                <>
                    <RiFileDownloadLine size="2rem"/>
                    <div className="text-center">
                        <p>Faites glisser {maxFiles === 1 ? "votre fichier" : "vos fichiers"} ici</p>
                        {acceptInfo && <p className="text-xs">Acceptés : {acceptInfo}</p>}
                        {isTooLarge && (
                            <p className={"text-red-500 font-bold"}>Le fichier est trop lourd.</p>
                        )}
                        {isInvalid && (
                            <p className={"text-red-500 font-bold"}>Le format du fichier n&apos;est pas correct.</p>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}